import * as React from 'react';
import "./MessageElement.scss";
import { useEffect, useState } from 'react';
import { MessageDefines, MessageProps } from './IMessage';
import useActionExecutor from '../service/actionExecutor';
import { ColorDefines } from '../../interface/IColors';

interface MessageElementProps {
  props: MessageProps;
  defines: MessageDefines;
  colors: ColorDefines;
}

const MessageElement = ({ props, defines, colors }: MessageElementProps) => {
  const [value, setValue] = useState(defines.text);
  const { change } = useActionExecutor(props.event, defines);

  useEffect(() => {
    if (defines.url) {
      fetch(defines.url)
        .then(res => res.json())
        .then(res => {
          const result = defines.callback ? 
            defines.callback(res) : res;
          setValue(result);
          if (change) change();
        });
    }
  }, []);

  return (
    <div className="message" dangerouslySetInnerHTML={{ __html: value }}></div>
  );
}

export default MessageElement;